import React, { useMemo, useState } from 'react'
import IcnStyleSwitcher, { Style } from './IcnStyleSwitcher'
import styles from './ITFAvatarSelector.module.scss'
import { action, people } from './SelectAvatarModal'
import { useTranslation } from 'react-i18next'
import { AppState } from 'redux/reducers'
import { useSelector } from 'react-redux'
import avatars from './avatars'
import { Female, Male } from 'components/Icons'
import { transformLocalAssetUrl } from 'utils'
import classNames from 'classnames'
import { AccountDetails } from 'types/global'

interface Props {
  selectedView: string
  setSelectedAvatarUrl: (string) => void
}

const ITFAvatarSelector = ({ selectedView, setSelectedAvatarUrl }: Props) => {
  const { t } = useTranslation('strSelectAvatar')

  const male = { key: 'Male', icon: <Male /> }
  const female = { key: 'Female', icon: <Female /> }

  const currentAvatarUrl = useSelector(
    (state: AppState) =>
      (state.user.accountDetails as AccountDetails | null)?.biographicalInformation?.avatarUrl
  )

  const [activeStyle, setActiveStyle] = useState<Style>(male)

  const [selectedAvatar, setSelectedAvatar] = useState<string>(currentAvatarUrl || '')

  const toggleSecondaryView = key =>
    key === male.key ? setActiveStyle(male) : setActiveStyle(female)

  const handleSetSelectedAvatar = url => {
    setSelectedAvatar(url)
    setSelectedAvatarUrl(url)
  }

  const { actionAvatars, peopleFemaleAvatars, peopleMaleAvatars } = useMemo(() => {
    const { actionAvatars, peopleFemaleAvatars, peopleMaleAvatars } = avatars || {}

    return {
      actionAvatars: actionAvatars.map(avatar => ({
        url: transformLocalAssetUrl(avatar.url.default),
        alt: avatar.alt,
      })),
      peopleFemaleAvatars: peopleFemaleAvatars.map(avatar => ({
        url: transformLocalAssetUrl(avatar.url.default),
        alt: avatar.alt,
      })),
      peopleMaleAvatars: peopleMaleAvatars.map(avatar => ({
        url: transformLocalAssetUrl(avatar.url.default),
        alt: avatar.alt,
      })),
    }
  }, [])

  const AvatarList = ({ avatars }) => {
    return (
      <>
        {avatars.map((avatar, i) => (
          <div
            key={i}
            className={classNames(styles.avatarImgWrapper, {
              [styles.active]: selectedAvatar && selectedAvatar === avatar.url,
            })}
          >
            <img
              src={avatar.url}
              alt={avatar.alt}
              onClick={() => handleSetSelectedAvatar(avatar.url)}
            />
          </div>
        ))}
      </>
    )
  }

  return (
    <div>
      {selectedView === action.key && (
        <>
          <h3 className={styles.heading}>{`${t('chooseAvatar')}:`}</h3>
          <div className={styles.avatarsWrapper}>
            <AvatarList avatars={actionAvatars} />
          </div>
        </>
      )}

      {selectedView === people.key && (
        <>
          <IcnStyleSwitcher
            onSelect={toggleSecondaryView}
            heading={`${t('chooseAvatar')}:`}
            selected={activeStyle}
            selections={[male, female]}
            classIconActive={styles.iconActive}
            classIconInactive={styles.iconInactive}
          />

          {activeStyle.key === male.key && (
            <div className={styles.avatarsWrapper}>
              <AvatarList avatars={peopleMaleAvatars} />
            </div>
          )}
          {activeStyle.key === female.key && (
            <div className={styles.avatarsWrapper}>
              <AvatarList avatars={peopleFemaleAvatars} />
            </div>
          )}
        </>
      )}
    </div>
  )
}

export default ITFAvatarSelector
